import React, { useState } from "react";

import { Button } from "../../../components/common";
import { useStaticData } from "../../../hooks/useStaticData";
import WrappedSection from "../../WrappedSection/WrappedSection";
import SectionStandardSignPostCards from "../SectionStandardSignPostCards";
import * as styles from "./SectionOurStoriesListByTopic.module.scss";
export interface SectionOurStoriesListByTopicProps {
	heading: string;
	topic: string;
	jumpLinksTitle?: string;
}

export const getSectionOurStoriesListByTopicProps = ({
	field_front_end_title,
	field_jump_links_title,
}: Queries.SectionDataFragment) => ({
	heading: field_front_end_title,
	jumpLinksTitle: field_jump_links_title,
});

// TODO - TEST STATIC
export const SectionOurStoriesListByTopic: React.FC<
	SectionOurStoriesListByTopicProps
> = ({ heading, topic, jumpLinksTitle }) => {
	const { ourStoriesProps } = useStaticData(["ourStoriesProps"]);

	const [showCount, setShowCount] = useState(6);

	const selectedStories = ourStoriesProps
		.filter((story) => story.topics?.includes(topic))
		.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

	const calculateLoaded = (count: number) =>
		`${(count / selectedStories.length) * 100}%`;

	// Maps the items into groups of 6 with a break inbetween
	const mappedStories = selectedStories.reduce(
		(
			acc: DogsTrust.SignPostCardProps[][],
			curr: DogsTrust.SignPostCardProps,
			i,
		) => {
			if (i > showCount - 1) return acc;
			if (i % 6 === 0) {
				acc.push([curr]);
			} else {
				acc[acc.length - 1].push(curr);
			}
			return acc;
		},
		[] as DogsTrust.SignPostCardProps[][],
	);

	return (
		<WrappedSection sectionName="SectionOurStoriesListByTopicResults">
			{jumpLinksTitle ? (
				<h2 className={styles.title} data-jumplinkstitle={jumpLinksTitle}>
					{heading}
				</h2>
			) : (
				<h2 className={styles.title}>{heading}</h2>
			)}
			{mappedStories.map((storySet, i) => {
				if (i === 0)
					return (
						<SectionStandardSignPostCards
							key={storySet.map((s) => s.title).join("-")}
							withPageBreak={false}
							isSubComponent
							items={storySet}
							isThreeColLayout={true}
						/>
					);
				return (
					<>
						<div
							key={`pagebreak-${
								// biome-ignore lint/suspicious/noArrayIndexKey: Legit use of index as key here
								i
							}`}
							className={styles.paginationbreak}
							role="alert"
							aria-label={`PAGE ${i + 1} of results loaded`}
						>{`PAGE ${i + 1}`}</div>

						<SectionStandardSignPostCards
							key={storySet.map((s) => s.title).join("-")}
							withPageBreak={false}
							isSubComponent
							items={storySet}
							isThreeColLayout={true}
						/>
					</>
				);
			})}

			<div className={styles.viewmorewrapper}>
				<div className={styles.viewmoretext}>
					{`Viewed ${
						showCount <= selectedStories.length
							? showCount
							: selectedStories.length
					} of ${selectedStories.length}`}
				</div>
				<div className={styles.loadingbar}>
					<div
						className={styles.loadingbarfiller}
						style={{
							width: calculateLoaded(
								showCount <= selectedStories.length
									? showCount
									: selectedStories.length,
							),
						}}
					/>
				</div>
				{showCount < selectedStories.length && (
					<Button
						variant="tertiary"
						onClick={() => setShowCount((showCount) => showCount + 6)}
					>
						Load more
					</Button>
				)}
			</div>
		</WrappedSection>
	);
};

export default SectionOurStoriesListByTopic;
